if (process.env.NODE_ENV === 'production') {
  module.exports = require('./button.production.js');
} else {
  module.exports = require('./button.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/button/dist/es/button.js
// module id = 172
// module chunks = 0